module.exports = __webpack_public_path__ + "static/media/DancingRoses.e8959276.jpg";